<!-- <mat-toolbar color="primary">
    <button [fxShow.lt-md]="true" [fxShow]="false"  mat-icon-button (click)="openSidenav()">
        <mat-icon>menu</mat-icon>
    </button>
    <span>EIN Configuration</span>
</mat-toolbar> -->
<div class="content" fxLayout="column" fxLayoutGap="10px"
    [@routeAnimation]="true">
    <form class="form-content" [formGroup]="einExpDate" class="content"
        fxLayout="column" fxLayoutGap="15px" enctype="multipart/form-data">
        <div fxLayout="column" fxLayoutGap="12px">
            <mat-form-field fxLayout="row" fxLayout.lt-sm="column">
                <input matInput [matDatepicker]="picker1"
                    formControlName="startDate" readonly [max]='maxDate'
                    placeholder="EINs need to be verified again by:"
                    fxFlex="60%" fxFlexFill>
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
            <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center"
                fxLayout.lt-sm="column">
                <button fxFlex="15%" fxFlexFill mat-raised-button
                    color="primary" *ngIf="einExpDate.dirty"
                    (click)="saveExpDate()">Save</button>
            </div>
        </div>
    </form>
    <mat-tab-group #tabGroup mat-stretch-tabs>
        <mat-tab label= "Exception List">
            <div class="ein-table-container" *ngIf="tabGroup.selectedIndex ===
                0">
                <ein-config-table-component [data]="einExceptionOrgDetail"
                    tableType='exception'>
                </ein-config-table-component>
            </div>
        </mat-tab>
        <mat-tab label="GuideStar Verified EIN">
            <div class="ein-table-container" *ngIf="tabGroup.selectedIndex ===
                1">
                <ein-config-table-component [data]="einGuideStarOrgDetail"
                    tableType='GuideStar'>
                </ein-config-table-component>
            </div>
        </mat-tab>
    </mat-tab-group>

</div>